interface NavigationItem {
  id: string;
  label: string;
  path: string;
  children?: NavigationItem[];
}

interface FooterNavigationItem {
  label: string;
  path: string;
  external?: boolean;
}

interface FooterNavigationSection {
  title: string;
  items: FooterNavigationItem[];
}

export const navigationData: NavigationItem[] = [
  {
    id: 'home',
    label: 'nav.home',
    path: '/'
  },
  {
    id: 'about',
    label: 'nav.about',
    path: '/about',
    children: [
      {
        id: 'about-company',
        label: 'navigation.aboutCompany',
        path: '/about/company'
      },
      {
        id: 'about-history',
        label: 'navigation.aboutHistory',
        path: '/about/history'
      },
      {
        id: 'about-honors',
        label: 'navigation.aboutHonors',
        path: '/about/honors'
      },
      {
        id: 'about-organization',
        label: 'navigation.aboutOrganization',
        path: '/about/organization'
      },
      {
        id: 'about-team',
        label: 'navigation.aboutTeam',
        path: '/about/team'
      }
      // { // 物流配送中心暂时隐藏
      //   id: 'about-logistics',
      //   label: 'navigation.aboutLogistics',
      //   path: '/about/logistics'
      // }
    ]
  },
  {
    id: 'news',
    label: 'nav.news',
    path: '/news'
  },
  {
    id: 'careers',
    label: 'nav.careers',
    path: '/careers',
    children: [
      {
        id: 'careers-social',
        label: 'navigation.careersSocial',
        path: '/careers/social'
      },
      {
        id: 'careers-campus',
        label: 'navigation.careersCampus',
        path: '/careers/campus'
      }
    ]
  },
  {
    id: 'investor',
    label: 'nav.investor',
    path: '/investor',
    children: [
      {
        id: 'investor-service',
        label: 'navigation.stockInfo',
        path: '/investor/service'
      },
      {
        id: 'investor-announcements',
        label: 'navigation.investorAnnouncements',
        path: '/investor/announcements'
      },
      {
        id: 'investor-financial-reports',
        label: 'navigation.investorFinancialReports',
        path: '/investor/financial-reports'
      },
      {
        id: 'investor-governance',
        label: 'navigation.investorGovernance',
        path: '/investor/governance'
      },
      {
        id: 'investor-inquiry',
        label: 'navigation.investorContact',
        path: '/investor/inquiry'
      }
    ]
  },
  {
    id: 'contact',
    label: 'nav.contact',
    path: '/contact'
  }
];

export const footerNavigation: Record<string, FooterNavigationSection> = {
  company: {
    title: 'footer.company.title',
    items: [
      { label: 'footer.company.about', path: '/about' },
      { label: 'footer.company.history', path: '/about#history' },
      { label: 'footer.company.team', path: '/about#team' },
      { label: 'footer.company.culture', path: '/about#culture' }
    ]
  },
  business: {
    title: 'footer.business.title',
    items: [
      { label: 'footer.business.products', path: '/products' },
      { label: 'footer.business.services', path: '/services' },
      { label: 'footer.business.solutions', path: '/solutions' },
      { label: 'footer.business.partners', path: '/partners' }
    ]
  },
  resources: {
    title: 'footer.resources.title',
    items: [
      { label: 'footer.resources.news', path: '/news' },
      { label: 'footer.resources.reports', path: '/investor#reports' },
      { label: 'footer.resources.downloads', path: '/downloads' },
      { label: 'footer.resources.support', path: '/support' }
    ]
  },
  legal: {
    title: 'footer.legal.title',
    items: [
      { label: 'footer.legal.privacy', path: '/privacy' },
      { label: 'footer.legal.terms', path: '/terms' },
      { label: 'footer.legal.cookies', path: '/cookies' },
      { label: 'footer.legal.compliance', path: '/compliance' }
    ]
  }
};